module.exports = __webpack_public_path__ + "static/fountain-fae9504b7e84d936ab282e92e7e8b145.jpg";